import {board, gameStages, starterUnits, units, unitTypes, actionColors, groundTypes} from './GameVariables';
import { arraysMatch } from './Utils';

export default function() {
    let that = this;
    this.getStarterUnits = function(team) {
        let arr = [];
        for(let item of starterUnits){
          arr.push({unit: item.unit(team), count: item.default});
        }
        return arr;
    }
    this.getTileByLocation = function(xPos, yPos) {
        return that.tileMap[yPos][xPos];
    }
    this.getUnitByLocation = function(xPos, yPos) {
        const unit = that.getTileByLocation(xPos, yPos).unit
        return unit;
    }
    this.getUnitById = function(unitId) {
        return Object.values(units).find(unit => unit().id === unitId);
    }
    this.showPointer = function(xPos, yPos, pointerColor) {
        let tile = that.getTileByLocation(xPos, yPos);
        tile.pointer.color = pointerColor;
        tile.pointer.enabled = true;
        that.updateTileMap();
    }
    this.hidePointer = function(xPos, yPos) {
        let tile = that.getTileByLocation(xPos, yPos);
        tile.pointer.color = 'none';
        tile.pointer.enabled = false;
        that.updateTileMap();
    }
    this.hideAllPointers = function() {
        for(let y = 0; y < that.tileMap.length; y++){
            for(let x = 0; x < that.tileMap[y].length; x++){
                let tile = that.getTileByLocation(x, y);
                if (tile.pointer.enabled){
                   that.hidePointer(x, y);
                }
            }
        }
        that.updateTileMap();
    }
    this.placeUnit = function(xPos, yPos, unit) {
        that.tileMap[yPos][xPos].unit = unit;
        that.updateTileMap();
    }
    this.hideUnit = function(xPos, yPos) {
        that.tileMap[yPos][xPos].unit = null;
        that.updateTileMap();
    }
    this.updateTileMap = function() {
        that.updaters.tileMap(that.tileMap);
    }
    this.updateGameStatus = function() {
        const gameStatus = {
            gameStage: that.gameStage,
            turnPlayer: that.turnPlayer,
            turnNumber: that.turnNumber
        };
        that.updaters.gameStatus(gameStatus);
    }
    this.initTileMap = function() {
        that.tileMap = [];
        for(let i = 0; i < that.board.length; i++){
            that.tileMap.push([]);
            for(let j = 0; j < that.board[i].length; j++){
                let obj = {
                    groundType: that.board[i][j],
                    pointer: {enabled: false, color: 'none'},
                    unit: null,
                    cords: [j, i]
                };
                that.tileMap[i].push(obj);
            }
        }
    }
    this.setPlacingTeam = function(team, updateUnitSelector=true) {
        if(that.placingTeam !== ''){
            if(team === 'red'){
                that.bluePlacingUnits = that.currentPlacingUnits;
            }
            else{
                that.redPlacingUnits = that.currentPlacingUnits;
            }
        }
        if(team === 'red'){
            that.currentPlacingUnits = that.redPlacingUnits;
        }
        else{
            that.currentPlacingUnits = that.bluePlacingUnits;
        }
        that.placingTeam = team;
        if(updateUnitSelector) {
            that.updaters.unitSelector(that.currentPlacingUnits);
        }
    }
    this.setPlacingUnit = function(unitId) {
        that.placingUnit = unitId;
    }
    this.renderSelectModeMoves = function() {
        for(let move of that.selectModeMoves){
            this.showPointer(...move.cords, actionColors[move.action]);
        }
    }
    that.detectMoveType = function(oldXpos, oldYpos, newXpos, newYpos) {
        const tile = that.getTileByLocation(oldXpos, oldYpos);
        let unit = tile.unit;

        const targetTile = that.getTileByLocation(newXpos, newYpos);
        const targetUnit = targetTile.unit;
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }

        if(targetUnit && targetUnit.team !== unit.team && targetUnit.type === 'troop' && that.virtualUnit && unit.id === 'flag'){
            return 'load';
        }
        else if(targetUnit && targetUnit.team === unit.team && targetUnit.isVehicle && that.vehicleCanLoadUnit(targetUnit, unit)){
            // If the target unit is a friendly vehicle and the unit can be loaded into it
            return 'load';
        }
        else if(unit.moveOn.includes(targetTile.groundType)){
            // If the unit can possibly step on the target ground type
            if(targetUnit){
                // If target tile isn't empty
                if(targetUnit.team !== unit.team && !unit.static){
                    // If an enemy is the target
                    if((tile.groundType === targetTile.groundType || unit.type === 'jet') && !that.virtualUnit){
                        // If both tiles are land or sea (units can't attack from sea to land and vice versa)
                        return 'attack';
                    }
                }
            }
            else if(!unit.static && !that.virtualUnit){
                // If the tile is empty, the unit can move there
                return 'move';
            }
            else if(that.virtualUnit){
                return 'unload';
            }
        }
    }
    this.enableSelectMode = function(xPos, yPos) {
        const breakMoveTypes = ['attack', 'load', undefined];
        let moveType;

        const jetMovement = function(xPos, yPos, targetXpos, targetYpos){
            moveType = that.detectMoveType(xPos, yPos, targetXpos, targetYpos);
            if(moveType){
                that.selectModeMoves.push({cords: [targetXpos, targetYpos], action: moveType});
            }
            if(breakMoveTypes.includes(moveType)){
                return true;
            }
            return false;
        }
        const tile = that.getTileByLocation(xPos, yPos);
        let unit = tile.unit;
        if((unit.type === 'troop' && unit.isCarryingFlag) || unit.isVehicle){
            that.updateUnloadUnits(unit.unitsCurrentlyLoaded);
        }
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }

        if(unit.type !== unitTypes.jet || that.virtualUnit){
            const cordsArr = [
                [xPos + 1, yPos],
                [xPos - 1, yPos],
                [xPos, yPos + 1],
                [xPos, yPos - 1],
            ];
            for(let cords of cordsArr){
                if(cords[0] >= 0 && cords[0] < that.tileMap.length && cords[1] >= 0 && cords[1] < that.tileMap.length){
                    moveType = that.detectMoveType(xPos, yPos, ...cords);
                    if(moveType){
                        that.selectModeMoves.push({cords: cords, action: moveType});
                    }
                }
            }
        }
        else{
            let targetXpos = xPos;
            let targetYpos = yPos;
            let breakSignal = false;
            for(let i = xPos; i < that.tileMap.length - 1; i++){
                targetXpos = i + 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            for(let i = xPos; i > 0; i--){
                targetXpos = i - 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            targetXpos = xPos;
            for(let i = yPos; i < that.tileMap.length - 1; i++){
                targetYpos = i + 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            for(let i = yPos; i > 0; i--){
                targetYpos = i - 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
        }

        if(that.selectModeMoves.length > 0 || that.virtualUnit){
            that.renderSelectModeMoves();
            that.selectedUnitCords = [xPos, yPos];
            that.selectMode = true;
            that.updaters.selectMode(that.selectMode);
        }
    }
    this.disableSelectMode = function(keepVirtualUnit=false) {
        that.selectModeMoves = [];
        that.hideAllPointers();
        that.selectMode = false;
        if(!keepVirtualUnit){
            that.virtualUnit = null;
        }
        that.updaters.selectMode(that.selectMode);
    }
    this.addToDeadHall = function (unit){
        // Dead hall is built from unit/count pairs
        const deadHall = unit.team === 'red' ? that.redDeadHall : that.blueDeadHall;
        const unitCounter = deadHall.find(val => val.unit.id === unit.id);
        if(unitCounter) {
            unitCounter.count++;
        }
        else {
            deadHall.push({unit: that.getUnitById(unit.id)(), count: 1});
        }
        if(unit.team === 'red') {
            that.redDeadHall = deadHall;
        }
        else {
            that.blueDeadHall = deadHall;
        }
        const updater = that.updaters.deadHall;
        if(updater){
            updater(unit.team, deadHall);
        }
    }
    this.getVehicleModifiers = function(unitList){
        if(!Array.isArray(unitList)){
            unitList = [unitList];
        }
        const modifiers = [];
        const getModifier = function(by, name) {
            return modifiers.find(val => val.by === by && val.name === name);
        }
        const setModifier = function(by, name, count) {
            const modifier = getModifier(by, name);
            if(modifier){
                modifier.count = count;
            }
            else{
                modifiers.push({by, name, count});
            }
        }
        const updateModifier = function(by, name, manipulator) {
            const modifier = getModifier(by, name);
            if(modifier){
                modifier.count += manipulator;
            }
            else{
                modifiers.push({by, name, count: manipulator});
            }
        }
        for(let unit of unitList){
            if (unit.isCarryingFlag){
                updateModifier('type', 'troop', 1);
            }
            if (unit.isVehicle){
                if(unit.type === 'boat'){
                    setModifier('type', 'boat', 1);
                }
                else{
                    updateModifier('id', unit.id, 1);
                }
                for(let loadedUnit in unit.unitsCurrentlyLoaded){
                    updateModifier('type', loadedUnit.type, 1);
                }
            }
            else{
                updateModifier('type', unit.type, 1);
            }
        }
        return modifiers;
    }
    this.countUnitsOnVehicle = function(vehicle) {
        let count = 0;
        for(let unit of vehicle.unitsCurrentlyLoaded){
            if(unit.isVehicle){
                count += that.countUnitsOnVehicle(unit) + 1;
            }
            else{
                count++;
            }
        }
        return count;
    }
    this.vehicleCanLoadUnit = function(vehicle, unit) {
        /* This function checks if a unit can be loaded into a jet or a boat. */
        // If a vehicle tries to enter another vehicle, all of it's units will be loaded on the carrier.
        if(unit.isCarryingFlag && !vehicle.canCarryFlag){
            return false;
        }
        const vehicleModifiers = that.getVehicleModifiers(vehicle.unitsCurrentlyLoaded);
        let unitModifiers;
        if(unit.isVehicle){
            const unitClone = {...unit};
            unitClone.unitsCurrentlyLoaded = [];
            unitModifiers = that.getVehicleModifiers([unitClone].concat(unit.unitsCurrentlyLoaded));
        }
        else{
            unitModifiers = that.getVehicleModifiers(unit);
        }
        const modifiers = [unitModifiers, vehicleModifiers];

        const unitMatch = vehicle.capacity.find(val => {
            return (val.by === 'type' && val.name === unit.type) || (val.by === 'id' && val.name === unit.id);
        });
        if(!unitMatch){
            return false;
        }
        for(let capacity of vehicle.capacity){
            let count = capacity.count;
            for(let modifierList of modifiers){
                const modifier = modifierList.find(val => capacity.by === val.by && capacity.name === val.name);
                if(modifier){
                    count -= modifier.count;
                }
            }
            if(count < 0){
                return false;
            }
        }
        return true;
    }
    this.killUnit = function(unitXpos, unitYpos) {
        let tile, unit;
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }
        else{
            tile = that.getTileByLocation(unitXpos, unitYpos);
            unit = tile.unit;
            that.hideUnit(unitXpos, unitYpos);
        }
        if(unit.isVehicle){
            for(let loadedUnit of unit.unitsCurrentlyLoaded){
                that.virtualUnit = loadedUnit;
                this.killUnit();
            }
        }
        if(tile && unit.isCarryingFlag && groundTypes.ground.includes(tile.groundType)){
            tile.unit = unit.unitsCurrentlyLoaded.find(val => val.id === 'flag');
        }
        that.addToDeadHall(unit);
    }
    this.setUnloadingUnit = function(unitIndex){
        const vehicle = that.getUnitByLocation(...that.selectedUnitCords);
        const unit = vehicle.unitsCurrentlyLoaded[unitIndex];
        if(unitIndex == -1){
            that.virtualUnit = null;
        }
        else if(unit){
            that.virtualUnit = unit;
            that.virtualUnitId = unitIndex;
        }
        that.disableSelectMode(true);
        that.enableSelectMode(...that.selectedUnitCords);
    };
    this.removeUnitFromVehicle = function(vehicleXpos, vehicleYpos, unitId) {
        const vehicle = that.getUnitByLocation(vehicleXpos, vehicleYpos);
        const unit = vehicle.unitsCurrentlyLoaded ? vehicle.unitsCurrentlyLoaded[unitId] : null;
        let flag = false;
        if(unit){
            // If the unit to unload exist
            if(vehicle.isVehicle || (vehicle.type === 'troop' && vehicle.isCarryingFlag)){
                // If the unit is a vehicle or a troop carrying flag
                if(unit.isCarryingFlag || unit.id === 'flag'){
                    // If the unit is carrying flag or the flag itself
                    // The vehicle is no longer carrying flag
                    vehicle.isCarryingFlag = false;
                }
                vehicle.unitsCurrentlyLoaded.splice(unitId, 1);
                flag = true;
            }
        }
        return flag;
    }
    this.updateUnloadUnits = function(unloadUnits) {
        that.updaters.unloadUnits(unloadUnits);
    }
    this.moveUnit = function (oldXpos, oldYpos, newXpos, newYpos) {
        const unit = that.getUnitByLocation(oldXpos, oldYpos);
        that.hideUnit(oldXpos, oldYpos);
        that.placeUnit(newXpos, newYpos, unit)
    }
    this.loadUnit = function(unitXpos, unitYpos, vehicleXpos, vehicleYpos) {
        let unit = that.getUnitByLocation(unitXpos, unitYpos);
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }
        const vehicle = that.getUnitByLocation(vehicleXpos, vehicleYpos);

        const moveUnitToVehicle = function(unitToLoad) {
            if(!that.allowNestedVehicles && unitToLoad.isVehicle){
                for(let loadedUnit of unitToLoad.unitsCurrentlyLoaded){
                    vehicle.unitsCurrentlyLoaded.push(loadedUnit);
                }
                unitToLoad.unitsCurrentlyLoaded = [];
                vehicle.isCarryingFlag = unitToLoad.isCarryingFlag;
                unitToLoad.isCarryingFlag = false;
            }
            vehicle.unitsCurrentlyLoaded.push(unitToLoad);
        }

        if(unit && vehicle){
            if(unit.type === 'flag' && vehicle.type === 'troop' && unit.team !== vehicle.team){
                vehicle.isCarryingFlag = true;
                moveUnitToVehicle(unit);
                that.removeUnitFromVehicle(unitXpos, unitYpos, that.virtualUnitId);
            }
            else if(vehicle.isVehicle && that.vehicleCanLoadUnit(vehicle, unit)){
                moveUnitToVehicle(unit);
                if(unit.isCarryingFlag){
                    vehicle.isCarryingFlag = true;
                }
                if(that.virtualUnit){
                    that.removeUnitFromVehicle(unitXpos, unitYpos, that.virtualUnitId);
                }
                else{
                    that.hideUnit(unitXpos, unitYpos);
                }
            }
        }
    }
    this.unloadUnit = function(vehicleXpos, vehicleYpos, tileXpos, tileYpos) {
        const unit = that.virtualUnit;
        const tile = that.getTileByLocation(tileXpos, tileYpos);
        const removed = that.removeUnitFromVehicle(vehicleXpos, vehicleYpos, that.virtualUnitId);
        if(removed){
            that.virtualUnit = null;
            that.virtualUnitId = -1;
            that.placeUnit(tileXpos, tileYpos, unit);
            if(unit.id === 'flag' && tile.groundType === 'i'){
                // Checking for winning condition - a unit has unloaded enemy flag into it's island. 
                let winner;
                if(tileYpos < 10 && unit.team === 'red'){
                    winner = 'blue';
                }
                else if(unit.team === 'blue'){
                    winner = 'red';
                }
                if(winner){
                    setTimeout(() => {that.declareWinner(winner)}, 100);
                }
            }
        }
    }
    this.attackUnit = function(attackerXpos, attackerYpos, targetXpos, targetYpos){
        const attacker = that.getUnitByLocation(attackerXpos, attackerYpos);
        const target = that.getUnitByLocation(targetXpos, targetYpos);
        let attackGroundType = that.getTileByLocation(targetXpos, targetYpos).groundType;
        let flagCaptured = false;
        let winner;
        if(attacker.team != target.team && attacker.moveOn.includes(attackGroundType)){
            if(groundTypes.ground.includes(attackGroundType)){
                if(target.id === 'flag'){
                    flagCaptured = true;
                }
                else if(target.id === "groundBomb"){
                    if(attacker.canDefuseLandmines){
                        // Attacker wins
                        winner = "attacker";
                    }
                    else{
                        // Target wins
                        winner = "target";
                    }
                }
                else if(target.id === "seaBomb"){
                    if(attacker.canDefuseSeamines){
                        // Attacker wins
                        winner = "attacker";
                    }
                    else{
                        // Target wins
                        winner = "target";
                    }
                }
                else if (attacker.groundLevel > target.groundLevel){
                    // Attacker wins
                    winner = "attacker";
                }
                else if(attacker.groundHighTier && target.groundHighTier && target.id != attacker.id){
                    // Attacker wins
                    winner = "attacker";
                }
                else if(attacker.groundLevel < target.groundLevel){
                    // Target wins
                    winner = "target";
                }
                else{
                    // Both lose
                    winner = "none";
                }
            }
            else{
                if(target.id === "seaBomb"){
                    if(attacker.canDefuseSeamines){
                        // Attacker wins
                        winner = "attacker";
                    }
                    else{
                        // Target wins
                        winner = "target";
                    }
                }
                else if (attacker.seaLevel > target.seaLevel){
                    // Attacker wins
                    winner = "attacker";
                }
                else if(attacker.seaHighTier && target.seaHighTier && target.id != attacker.id){
                    // Attacker wins
                    winner = "attacker";
                }
                else if(attacker.seaLevel < target.seaLevel){
                    // Target wins
                    winner = "target";
                }
                else{
                    // Both lose
                    winner = "none";
                }
            }
            if(flagCaptured){
                that.loadUnit(targetXpos, targetYpos, attackerXpos, attackerYpos);
                that.hideUnit(targetXpos, targetYpos);
                that.moveUnit(attackerXpos, attackerYpos, targetXpos, targetYpos);
            }
            else if(winner === "attacker"){
                that.killUnit(targetXpos, targetYpos);
                if(!(groundTypes.ground.includes(attackGroundType) && target.isCarryingFlag)){
                    that.moveUnit(attackerXpos, attackerYpos, targetXpos, targetYpos);
                }
            }
            else if(winner === "target"){
                that.killUnit(attackerXpos, attackerYpos);
            }
            else{
                that.killUnit(attackerXpos, attackerYpos);
                that.killUnit(targetXpos, targetYpos);
            }
        }
    }
    this.declareWinner = function(winner) {
        alert(winner + ' wins!');
    }
    this.onTileClick = function(tileXpos, tileYpos) {
        const tile = that.getTileByLocation(tileXpos, tileYpos);
        const unit = tile.unit;
        if(!that.selectMode){
            // If select mode isn't activated
            if(!unit){
                // If the tile is empty
                const unitCounter =  that.currentPlacingUnits.find(val => val.unit.id === that.placingUnit);
                if(unitCounter.count > 0){
                    // If there are enough units for placement
                    const unitToPlace = that.getUnitById(that.placingUnit)(that.placingTeam);
                    if(unitToPlace.prepPlacements.includes(tile.groundType)){
                        // All conditions match --> Place a unit
                        that.placeUnit(tileXpos, tileYpos, unitToPlace);
                        unitCounter.count--;
                        that.updaters.unitSelector(that.currentPlacingUnits);
                    }
                }
            }
            else{
                // If there is currently a unit on the tile, enable select mode
                that.enableSelectMode(tileXpos, tileYpos); 
            }
        }
        else{
            // If select mode is enabled
            const actionFuncs = {
                move: that.moveUnit,
                attack: that.attackUnit,
                load: that.loadUnit,
                unload: that.unloadUnit
            };
            const cords = [tileXpos, tileYpos];
            let moveDone = false;
            for(let move of that.selectModeMoves){
                if(arraysMatch(cords, move.cords)){
                    // If an active tile is clicked, the right move is being executed
                    const actionFunc = actionFuncs[move.action];
                    if(actionFunc) {
                        actionFunc(...that.selectedUnitCords, tileXpos, tileYpos);
                        moveDone = true;
                    }
                    break;
                }
            }
            if(!arraysMatch([tileXpos, tileYpos], that.selectedUnitCords)){
                // If selected unit itself isn't clicked
                that.disableSelectMode();
                if(!moveDone && that.getUnitByLocation(tileXpos, tileYpos)){
                    // If player wants to switch focus to another unit
                    that.onTileClick(tileXpos, tileYpos);
                }
            }
        }
    }
    this.saveScenario = function(scenarioId) {
        scenarioId = parseInt(scenarioId);
        const scenarioName = 'scenario' + scenarioId;
        const scenario = {
            tileMap: this.tileMap,
            redDeadHall: this.redDeadHall,
            blueDeadHall: this.blueDeadHall,
            redPlacingUnits: this.redPlacingUnits,
            bluePlacingUnits: this.bluePlacingUnits,
        };
        localStorage.setItem(scenarioName, JSON.stringify(scenario));
        this.scenarios[scenarioId-1] = scenario;
    }
    this.loadScenario = function(scenarioId){
        scenarioId = parseInt(scenarioId);
        this.reset(false, scenarioId);
    }
    this.loadScenarios = function() {
        const scenarios = [];
        let scenario;
        let scenarioName;
        for(let i = 0; i < this.numOfScenarios; i++){
            scenarioName = 'scenario' + (i + 1);
            scenario = localStorage.getItem(scenarioName);
            if(!scenario){
                scenario = {};
                localStorage.setItem(scenarioName, JSON.stringify(scenario));
            }
            else{
                try{
                    scenario = JSON.parse(scenario);
                }
                catch(err){
                    localStorage.removeItem(scenarioName);
                }
            }
            scenarios.push(scenario);
        }
        this.scenarios = scenarios;
    }
    this.reset = function(init=false, scenarioId=-1){
        const loadScenario = scenarioId > 0;

        this.gameStage = gameStages.prepStage;
        this.turnPlayer = 'red';
        this.turnNumber = 0;

        this.redPlacingUnits = this.getStarterUnits('red');
        this.bluePlacingUnits = this.getStarterUnits('blue');
        this.placingUnit = units.seaDefuserTroopObject().id;
        this.currentPlacingUnits = [];
        this.placingTeam = '';

        this.blueDeadHall = [];
        this.redDeadHall = [];
        
        this.selectedUnitCords = [];
        this.selectModeMoves = [];
        this.selectMode = false;
        this.virtualUnit = null;
        this.virtualUnitId = -1;

        this.board = board;
        this.tileMap = [];

        if(loadScenario){
            this.loadScenarios();
            const scenario = this.scenarios[scenarioId-1];
            for(let key in scenario){
                this[key] = scenario[key];
            }
        }
        else{
            this.initTileMap();
        }

        if(init){
            this.allowNestedVehicles = true;
            this.updaters = {};
            this.loadScenarios();
        }
        else{
            this.disableSelectMode();
            this.updateTileMap();
            this.setPlacingTeam('red');
            this.updaters.teamSelector('red');
            this.updaters.deadHall('red', this.redDeadHall);
            this.updaters.deadHall('blue', this.blueDeadHall);
        }

    }

    this.numOfScenarios = 3;
    this.reset(true);
}